const locale = {
  APPLICATIONS: 'Ana Menü',
  DASHBOARD: 'Anasayfa',
  USERS: 'Kullanıcı Yönetimi',
  MANAGEMENT: 'Yönetim',
  EXAMPLE: 'Örnek Sayfa'
};

export default locale;
